export const ENR_MODAL_TITLE = "si.my-lists.section.enrichment.modal.upload.guidelines";
export const ENR_CONTACTS_MODAL_TITLE = "si.my-lists.section.enrichment.contacts.modal.upload.guidelines";
export const QUOTA = "si.my-lists.section.enrichment.modal.upload.quota";
export const CONTACTS_QUOTA = "si.my-lists.section.enrichment.modal.upload.contacts.quota";
export const ENR_OVER_LIMIT_ERROR = "si.my-lists.section.enrichment.modal.upload.overLimit.error";
export const ENR_COL_NUMBER_ERROR = "si.my-lists.section.enrichment.modal.upload.columnsNumber.error";
export const ENR_NOT_A_DOMAINS_ERROR = "si.my-lists.section.enrichment.modal.upload.notADomains.error";
export const ENR_FORMAT_ERROR = "si.my-lists.section.enrichment.modal.upload.format.error";
export const ENR_CONTACTS_OVER_LIMIT_ERROR = "si.my-lists.section.enrichment.modal.upload.contacts.overLimit.error";
export const ENR_CONTACTS_NO_FIELDS_ERROR =
    "si.my-lists.section.enrichment.modal.upload.contacts.noRequiredFields.error";
export const ENR_CONTACTS_QUOTA_ERROR = "si.my-lists.section.enrichment.modal.upload.contacts.quota.error";
export const ENR_CONTACTS_EMPTY_COLUMNS_ERROR =
    "si.my-lists.section.enrichment.modal.upload.contacts.emptyColumns.error";

export const LIST_GUIDELINES = "si.my-lists.section.enrichment.modal.guide.title";
export const ONE_OF_THE_COLUMN_TEXT = "si.my-lists.section.enrichment.modal.guide.domain";
export const MAXIMUM_ROWS_TEXT = "si.my-lists.section.enrichment.modal.guide.maximum.rows";
export const FIRST_ROW_HEADER_TEXT = "si.my-lists.section.enrichment.modal.guide.first.row";
export const FOURTH_ROW_HEADER_TEXT = "si.my-lists.section.enrichment.modal.guide.fourth.row";

export const MAXIMUM_CONTACTS_ROWS_TEXT = "si.my-lists.section.enrichment.modal.guide.contacts.maximum.rows";
export const HELP_TEXT = "si.my-lists.section.enrichment.modal.guide.contacts.help.text";
export const FILE_STRUCTURE_HEADING = "si.my-lists.section.enrichment.modal.guide.contacts.file.structure.heading";
export const FILE_STRUCTURE_FIRST_LAST_NAME =
    "si.my-lists.section.enrichment.modal.guide.contacts.file.structure.first.last.name";
export const FILE_STRUCTURE_TABLE_FIRST_NAME =
    "si.my-lists.section.enrichment.modal.guide.contacts.file.structure.table.first.name";
export const FILE_STRUCTURE_TABLE_LAST_NAME =
    "si.my-lists.section.enrichment.modal.guide.contacts.file.structure.table.last.name";
export const FILE_STRUCTURE_TABLE_COMPANY =
    "si.my-lists.section.enrichment.modal.guide.contacts.file.structure.table.company";
export const FILE_STRUCTURE_TABLE_FULLNAME =
    "si.my-lists.section.enrichment.modal.guide.contacts.file.structure.table.fullname";
export const FILE_STRUCTURE_FULLNAME = "si.my-lists.section.enrichment.modal.guide.contacts.file.structure.fullname";
export const FILE_STRUCTURE_LINKEDIN = "si.my-lists.section.enrichment.modal.guide.contacts.file.structure.linkedin";

export const ENRICHMENT_RESULT = "si.my-lists.section.enrichment.modal.enrich.title";
export const WEBSITES_TEXT = "si.my-lists.section.enrichment.modal.enrich.column.text";
export const TRAFFIC_TEXT = "si.my-lists.section.enrichment.modal.enrich.country-traffic.text";
export const REPLACE = "si.my-lists.section.enrichment.modal.enrich.replace.tooltip.text";

export const CONTACTS_MODAL_TITLE = "si.my-lists.section.enrichment.modal.enrich.contacts.title";
export const CONTACTS_MODAL_ENRICHMENT_TITLE = "si.my-lists.section.enrichment.modal.enrich.contacts.enrichment.title";

export const LINKEDIN_HEADER_TEXT = "si.my-lists.section.enrichment.modal.enrich.linkedin.header.text";
export const COMPANY_HEADER_TEXT = "si.my-lists.section.enrichment.modal.enrich.company.header.text";
export const FULLNAME_HEADER_TEXT = "si.my-lists.section.enrichment.modal.enrich.fullname.header.text";
export const FIRST_NAME_HEADER_TEXT = "si.my-lists.section.enrichment.modal.enrich.first-name.header.text";
export const LAST_NAME_HEADER_TEXT = "si.my-lists.section.enrichment.modal.enrich.last-name.header.text";

export const PLACEHOLDER_TEXT = "si.my-lists.section.enrichment.modal.enrich.placeholder.header.text";

export const HEADER_SELECTION_ERROR = "si.my-lists.section.enrichment.modal.enrich.select.header.error.text";

export const CANCEL = "si.common.button.cancel";
export const TOTAL = "si.my-lists.section.enrichment.modal.enrich.total";
export const TOTAL_SHORT = "si.my-lists.section.enrichment.modal.enrich.total.short";
export const DOWNLOAD = "si.my-lists.section.enrichment.modal.enrich.btn.primary.text";
export const NUMBER_OF_ADDED_FIELDS_TEXT = "si.my-lists.section.enrichment.modal.enrich.fields.help.text";
export const DISABLED_TOOLTIP_CONTENT =
    "si.my-lists.section.enrichment.modal.enrich.columns.disabled.item.tooltip.text";
export const ERROR_MSG = "si.my-lists.section.enrichment.modal.error.state.text";
export const DISABLED_LINKEDIN_TOOLTIP_CONTENT =
    "si.my-lists.section.enrichment.modal.enrich.columns.disabled.linkedin.tooltip.text";
export const DISABLED_FULLNAME_TOOLTIP_CONTENT =
    "si.my-lists.section.enrichment.modal.enrich.columns.disabled.fullname.tooltip.text";

export const TOTAL_CONTACTS = "si.my-lists.section.enrichment.modal.enrich.total.contacts";
export const TOTAL_CONTACTS_SHORT = "si.my-lists.section.enrichment.modal.enrich.total.contacts.short";
export const TOTAL_CONTACTS_TOOLTIP = "si.my-lists.section.enrichment.modal.enrich.total.contacts.tooltip";
export const DATA_CREDITS_CONTACTS_TOOLTIP =
    "si.my-lists.section.enrichment.modal.enrich.data-credits.contacts.tooltip";

export const CONFIG_SEARCH_TEXT = "si.my-lists.section.enrichment.modal.enrich.search.placeholder";
export const APPLY = "si.common.button.apply";
export const CLOSE = "si.common.button.close";
export const NOT_SELECTED = "si.my-lists.section.enrichment.modal.enrich.notSelected.text";
export const SELECT_HINT = "si.my-lists.section.enrichment.modal.enrich.notSelected.tooltip";
export const PREVIEW_HINT = "si.my-lists.section.enrichment.modal.enrich.preview.tooltip";

export const ENRICHMENT_HISTORY_TITLE = "si.my-lists.enrichment-history.modal.title";
export const SEARCH_CSV_PLACEHOLDER = "si.my-lists.enrichment-history.modal.search.placeholder";
export const NO_RESULTS = "si.my-lists.enrichment-history.modal.search.no.results";

export const DOWNLOAD_CSV_TOOLTIP = "si.my-lists.enrichment-history.download.tooltip";
export const TOTAL_LEADS = "si.my-lists.enrichment-history.total.title";
export const HISTORY_TOTAL_CONTACTS = "si.my-lists.enrichment-history.contacts.total.title";
export const TOTAL_ENRICHED = "si.my-lists.enrichment-history.successfully.enriched.title";
